// Report reasons for community moments and kudos.
//
// The reason enum itself lives in @healthos/schemas (CommunityReportReason);
// this module owns the member-facing label and explanation for each one, plus
// the display order. Web and mobile both render the same list, so the copy
// lives here rather than in either client.
export const COMMUNITY_REPORT_REASON_OPTIONS = [
    {
        reason: "health_private_info",
        label: "Private health details",
        body: "This includes weight, medication, diagnosis, or similar details.",
    },
    {
        reason: "harassment_unkind",
        label: "Unkind or harassment",
        body: "This feels targeted, hostile, or inappropriate for work.",
    },
    {
        reason: "inappropriate_image",
        label: "Inappropriate image",
        body: "The image does not belong on the company wall.",
    },
    {
        reason: "company_policy",
        label: "Company policy",
        body: "This needs review against workplace expectations.",
    },
    {
        reason: "other",
        label: "Something else",
        body: "A moderator should take a closer look.",
    },
];
/** Note field cap, mirroring ReportCommunityItemRequest.note in @healthos/schemas. */
export const COMMUNITY_REPORT_NOTE_MAX_LENGTH = 1200;
//# sourceMappingURL=community-report-reasons.js.map